export const INIT_SETTINGS = 'INIT SETTINGS';
export const TOGGLE_AUTO_IGNORE = '[Settings] toggle auto ignore';
